import React, { useRef, useState, useEffect } from "react";
import * as Yup from "yup";
import { ComponentDetails } from "../../../sc-models/facility-product-details-dto";
import FormBuilder from "../../../../../shared/components/form-builder/form-builder";
import { dtrackItService } from "../../../../transaction-certificates/tc-service/dtrackit.service";
import { API_ROUTES } from "../../../../../shared/app-configs/sc-app-config";
import { useParams } from "react-router-dom";
import { useApi } from "../../../../../shared/hooks/useApi";
import { useScStore } from "../../../../../store/scStandard.store";
import { Utills } from "../../../../../shared/app-configs/utilit";
import {
  EditableColumnDef,
  EditableTable,
} from "../../../../../shared/components/table/inline-edit-table";
import {
  CustomSelect,
  CustomTextField,
} from "../../../../../shared/components/inputfields/form-elements";
import { useFormik } from "formik";
import { useTransactionCertificateStore } from "../../../../../store/transaction-certificates.store";
import { Box } from "@mui/material";
import { StyledButton } from "../../../../../shared/components/buttons/custom-button";

export interface Option {
  value: string;
  label: string;
}

interface ComponentDetailsFormProps {
  formRef: any;
  componentData: ComponentDetails[];
  setComponentData: React.Dispatch<React.SetStateAction<ComponentDetails[]>>;
}

const ComponentDetailsForm: React.FC<ComponentDetailsFormProps> = ({
  formRef,
  componentData,
  setComponentData,
}) => {
  const [labelGrades, setLabelGrades] = useState<any>([]);
  const { scStandards } = useScStore();
  const [data, setData] = useState<ComponentDetails[]>(componentData ?? []);
  const [tableData, setTableData] = useState<ComponentDetails[]>(
    componentData ?? []
  );
  const [editingRowIndex, setEditingRowIndex] = useState<number | null>(null);
  const { isRestrictPopUpSave, setRestrictPopUpSave } =
    useTransactionCertificateStore();
  useEffect(() => {
    const getLabelGrades = async () => {
      try {
        const result: any =
          await dtrackItService.getStandradLabelGradeOnBasisOfSelectedStandard(
            [...scStandards, "NA"]
          );
        // Utills.cl(`result ${JSON.stringify(result)}`)
        const lblGrades = result.data.map((t: any) => ({
          value: t.code_1,
          label: `${t.description_1}  `,
        }));
        // Utills.cl(`lblGrades ${JSON.stringify(lblGrades)}`)
        setLabelGrades(lblGrades);
        // Utills.cl(`lblGrades ${lblGrades}`)
      } catch (err) {
        Utills.cl(`Error in Fetching Organic Farm Standard Code ${err}`);
      }
    };
    getLabelGrades();
  }, []);

  // const formConfig = {
  //   pageName:"",
  //   initialValues: componentData,
  //   validationSchema: Yup.object().shape({
  //     productComponentNo: Yup.string().optional(),
  //     componentDetail: Yup.string().optional(),
  //     componentStandardLabelGrade: Yup.array()
  //       .of(Yup.string())
  //       .optional(),
  //   }),
  //   sections: [
  //     {
  //       title: 'Product Component Details',
  //       fields: [

  //         {
  //           label: 'Product Component No.',
  //           name: 'productComponentNo',
  //           type: 'text',
  //           gridSize: { xs: 12, md: 6, lg: 4 },
  //           required: false,
  //           props: { placeholder: 'Enter Product Component No.' },
  //         },
  //         {
  //           label: 'Component Detail',
  //           name: 'componentDetail',
  //           type: 'text',
  //           gridSize: { xs: 12, md: 6, lg: 4 },
  //           required: false,
  //           props: {
  //             placeholder: 'Enter Component Detail',
  //           },
  //         },
  //         {
  //           label: 'Standard Label Grade',
  //           name: 'componentStandardLabelGrade',
  //           type: 'select',
  //           gridSize: { xs: 12, md: 6, lg: 4 },
  //           required: false,
  //           props: {
  //             multiple: true,
  //             options: labelGrades,
  //             placeholder: 'Select Standard Label Grade',
  //           },
  //         },
  //       ],
  //     },
  //   ],
  //   handleSubmit: (values: any) => {
  //     setComponentData(values);
  //   },
  // };
  const columns: EditableColumnDef<any>[] = [
    {
      accessorKey: "productComponentNo",
      header: "Product Component No.",
      enableHiding: false,
      renderEditCell: ({ value, onChange }) => (
        <CustomTextField
          name="productComponentNo"
          placeholder="Enter Product Component No."
          value={value}
          onChange={(e: any) => {
            onChange(e.target.value);
          }}
          sx={{ mb: 2 }}
        />
      ),
      minSize: 60,
      maxSize: 150,
    },
    {
      accessorKey: "componentDetail",
      header: "Component Details",
      enableHiding: false,
      minSize: 60,
      maxSize: 150,
      renderEditCell: ({ value, onChange }) => (
        <CustomTextField
          name="componentDetail"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Enter Component Detail"
          sx={{ mb: 2 }}
        />
      ),
    },
    {
      accessorKey: "componentStandardLabelGrade",
      header: "Standard Label Grade",
      enableHiding: false,
      minSize: 60,
      maxSize: 150,
      renderEditCell: ({ value, onChange }) => (
        <CustomSelect
          name="componentStandardLabelGrade"
          value={value}
          multiple={true}
          options={labelGrades}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Select Standard Label Grade"
          sx={{ mb: 2 }}
        />
      ),
    },
  ];

  const formik = useFormik<any>({
    initialValues: {
      productComponentNo: "", // Text field
      componentDetail: "", // Dropdown
      componentStandardLabelGrade: [],
    },
    validationSchema: Yup.object().shape({}),
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: () => {
      // Submission logic if needed
    },
  });
  /*** */
  const handleCellChange = (rowIndex: number, columnId: string, value: any) => {
    formik.setFieldValue(columnId, value);

    setData((prevData: any[]) =>
      prevData.map((row, index) =>
        index === rowIndex ? { ...row, [columnId]: value } : row
      )
    );
  };

  const handleAddNewRow = () => {
    const newRow: any = {
      productComponentNo: "", // Text field
      componentDetail: "", 
      componentStandardLabelGrade: [],// Dropdown
    };
    setData((prevData: any) => [...prevData, newRow]);
    setEditingRowIndex(data.length);
    setRestrictPopUpSave(true);
    formik.setValues(newRow);
    formik.setTouched({});
  };

  const handleCancelEdit = () => {
    if (editingRowIndex !== null) {
      // const isLastRow = editingRowIndex === data.length-1;
      // const currentRowValues = formik.values;
      // const isEmptyRow = Object.values(currentRowValues).every(
      //   (value) => !value || value === "" || (Array.isArray(value) && value.length === 0)
      // );

      // if (isLastRow && isEmptyRow) {
      //   setData((prevData: string | any[]) => prevData.slice(0, -1));
      // } else {
      //   formik.setValues(data[editingRowIndex]);
      // }
      setData(tableData);
    }
    setEditingRowIndex(null);
    setRestrictPopUpSave(false);
    formik.resetForm();
  };

  const handleSaveRow = () => {
    const currentRowValues = formik.values;
    const isEmptyRow = Object.values(currentRowValues).every(
      (value) =>
        !value || value === "" || (Array.isArray(value) && value.length === 0)
    );
    if (editingRowIndex === null || !formik.isValid || isEmptyRow) return;

    const updatedRow = {
      ...currentRowValues,
    };
    const newData:ComponentDetails[] = data.map((row: any, index: number) =>
      index === editingRowIndex ? updatedRow : row
    );
    setData(newData);
    setTableData(newData);
    setComponentData(newData);
    setEditingRowIndex(null);
    setRestrictPopUpSave(false);
    formik.resetForm();
  };

  const handleEditRow = (rowIndex: number) => {
    setEditingRowIndex(rowIndex);
    setRestrictPopUpSave(true);
    formik.setValues(data[rowIndex]);
  };

  const handleDeleteRow = (rowIndex: number) => {
    const updatedData = data.filter(
      (_: any, index: number) => index !== rowIndex
    );
    setData(updatedData);
    setTableData(updatedData);
    setComponentData(updatedData);
  };

  /*** */
  return (
    <>
      <Box display="flex" mb={3} justifyContent="flex-end" width="100%">
        <StyledButton
          disabled={!formik.isValid || isRestrictPopUpSave}
          onClick={handleAddNewRow}
          sx={{ mb: 2 }}
        >
          Add Product Component
        </StyledButton>
      </Box>
      <EditableTable
        data={data}
        columns={columns}
        onSaveRow={handleSaveRow}
        onCellChange={handleCellChange}
        editingRowIndex={editingRowIndex}
        onEditRow={handleEditRow}
        onCancelEdit={handleCancelEdit}
        onDeleteRow={handleDeleteRow}
        enableEditing={true}
        enablePagination = {false}
      />
    </>
  );
  // <FormBuilder formConfig={formConfig} onSubmit={formConfig.handleSubmit} formRef={formRef} />;
};

export default ComponentDetailsForm;
